'use strict';

/* eslint max-len: 0 */
/* eslint quotes: 0 */
/* eslint no-useless-escape: 0 */

module.exports = {
    checkIP: function ( ip ) {
        var check = /^([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})$/,
            octets, octet, index;

        if ( !ip || ip === '0.0.0.0' ) {
            return false;
        }

        if ( check.test(ip) ) {
            octets = ip.split('.');
            for ( index = 0; index < 4; index++ ) {
                octet = parseInt(octets[index], 10);
                if ( octet < 0 || octet > 255 ) {
                    return false;
                }
            }
        } else {
            return false;
        }

        return true;
    },

    /**
     * Returns whether the passed string is valid url.
     *
     * @param {string} url - url to validate
     * @param {boolean} [solution=false] - check solution
     * @param {boolean} [isSolutionOptional=false] - is solution optional or not
     * @param {boolean} [isProtocolOptional=true] - is protocol scheme optional or not
     *
     * @return {boolean} validate state
     */
    validateUrl: function ( url, solution, isSolutionOptional, isProtocolOptional ) {
        var solutionRegExp = '((ffmpeg|auto|rtp|rtsp|mp3|mpegps|mpegts|mp4|ifm|fm|ffrt|ffrt2|ffrt3|ffrt4)(\\s))';

        isProtocolOptional = typeof isProtocolOptional === typeof true ? isProtocolOptional : true;

        return new RegExp('^' + (solution ? solutionRegExp : '') + ['', '?'][+!!isSolutionOptional] + "(((http|https|udp|rtp|rtsp|mms|mmsh|mmst|rtmp|igmp):\\/\\/)" + ['', '?'][+isProtocolOptional] + "@?(([a-zA-Z0-9а-яА-Я$\\-_.+!*'(),;:&=]|%[0-9a-fA-Fа-яА-Я]{2})+@)?(((25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9]|[1-9][0-9]|[0-9])(\\.(25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9]|[1-9][0-9]|[0-9])){3})|localhost|([a-zA-Zа-яА-Я0-9\\-\\u00C0-\\u017F]+\\.)+([a-zA-Zа-яА-Я]{2,}))(:[0-9]+)?|((file:\/\/\/|\/)[a-zA-Zа-яА-Я0-9\\-\\u00C0-\\u017F]+))(\\/(([a-zA-Zа-яА-Я0-9$\\-_.+!*'(),;:@&=\\s]|%[0-9a-fA-Fа-яА-Я]{2})*(\\/([a-zA-Zа-яА-Я0-9$\\-_.+!*'(),;:@&=\\s]|%[0-9a-fA-Fа-яА-Я]{2})*)*)?(\\?([a-zA-Zа-яА-Я0-9$\\-_.+!*'(),;:@&=\\/?]|%[0-9a-fA-Fа-яА-Я]{2})*)?(\\#([a-zA-Zа-яА-Я0-9$\\-_.+!*'(),;:@&=\\/?]|%[0-9a-fA-Fа-яА-Я]{2})*)?)?$").test(url);
    }
};
